var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeDrawSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.711,28.235c-0.879-0.822-1.54-1.791-1.861-2.729c-1.5-4.39,0.702-7.177,2.644-9.636 c1.248-1.58,2.427-3.072,2.464-4.828c0.02-0.958,0.074-3.505-4.449-6.106L4.606,3.03c3.804,2.188,5.62,4.824,5.551,8.06 c-0.053,2.493-1.519,4.35-2.937,6.145c-1.825,2.311-3.401,4.306-2.289,7.561c0.2,0.585,0.679,1.271,1.282,1.835L4.711,28.235z  M13.565,19.004c-3.938,1.306-4.42,4.165-4.886,6.938c-0.201,1.196-0.409,2.433-0.894,3.561l-0.306,0.71L8.252,30.2 c3.036-0.05,6.929-1.294,8.783-3.962c0.864-1.243,1.159-2.671,0.895-4.177L13.565,19.004z M28.55,1.983 c-2.072-1.444-9.222,7.006-11.858,10.771c-1.155,1.651-1.992,3.419-2.493,4.618l4.8,3.361c0.954-0.88,2.33-2.271,3.486-3.922 c1.875-2.678,3.761-5.968,5.046-8.802C29.852,2.896,28.906,2.233,28.55,1.983z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeDrawSelected);
export default __webpack_public_path__ + "static/media/free-draw-selected.75e26b1f1d03d1c48a2cd77449f0f5e6.svg";
export { ForwardRef as ReactComponent };